import { getRecentConsultants } from "@/Context/api"
import { useQuery } from "@tanstack/react-query"

const useRecentConsultants = (enabled: boolean) => {
  const query = useQuery({
    queryKey: ["recent-consultants"],
    queryFn: getRecentConsultants,
    refetchOnWindowFocus: false,
    enabled
  });

  return query;
}

export default useRecentConsultants;